/**
 * Phone header status slot: the one icon shown next to the header's last
 * action (⋮ menu on Products, Settings on Home).
 *
 * Priority: offline → chat unread → notifications unread → the screen's own
 * fallback (null here).
 */
export type HeaderStatusSlot = 'offline' | 'chat' | 'notifications' | null;

export const pickHeaderStatusSlot = ({
  online,
  chatUnread,
  notificationsUnread,
}: {
  online: boolean;
  chatUnread: boolean;
  notificationsUnread: number;
}): HeaderStatusSlot => {
  if (!online) return 'offline';
  if (chatUnread) return 'chat';
  if (notificationsUnread > 0) return 'notifications';
  return null;
};
